import type { ColumnDef } from '@tanstack/react-table';
import DataTableSelectCheckbox from '../atoms/DataTableSelectCheckbox';

export interface ICreateDataTableSelectColumnOptions {
  /** Kolon ID. Varsayılan: 'select' */
  id?: string;
  /** Kolon genişliği (px). Varsayılan: 25 */
  size?: number;
  /** Header hücre için ek CSS sınıfı (meta.columnClassName) */
  columnClassName?: string;
  /** Hücre için ek CSS sınıfı (meta.cellClassName) */
  cellClassName?: string;
}

/**
 * DataTable için seçim (checkbox) kolonu tanımı döndürür.
 * enableRowSelection: true ile birlikte kullanılmalıdır.
 *
 * @example
 * ```tsx
 * const columns: ColumnDef<User>[] = [
 *   createDataTableSelectColumn(),
 *   { accessorKey: 'name', header: 'İsim' },
 *   { accessorKey: 'email', header: 'E-posta' },
 * ];
 *
 * <DataTable
 *   enableRowSelection
 *   columns={columns}
 *   ...
 * />
 *
 * // Seçili verileri almak için:
 * const selected = tableRef.current?.getSelectedRows<User>() ?? [];
 * ```
 */
export function createDataTableSelectColumn<TData = any>(
  options: ICreateDataTableSelectColumnOptions = {},
): ColumnDef<TData, any> {
  const { id = 'select', size = 25, columnClassName, cellClassName } = options;

  return {
    id,
    size,
    enableSorting: false,
    enableHiding: false,
    header: ({ table }) => <DataTableSelectCheckbox table={table} />,
    cell: ({ row, table }) => <DataTableSelectCheckbox table={table} row={row} />,
    meta: {
      columnClassName: columnClassName ?? 'w-25px pe-0',
      cellClassName: cellClassName ?? 'pe-0',
    },
  };
}
